import React from "react";
import "../../../assets/css/storytelling.css";

function LockIcon({ size = 16 }) {
    return (
        <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
            <path d="M7 11V7a5 5 0 0 1 10 0v4" />
        </svg>
    );
}

function BookIcon({ size = 16 }) {
    return (
        <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z" />
            <path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z" />
        </svg>
    );
}

function StoryCard({ story, locked, lang_id, user_id }) {
    const isCompleted = story.completed === 1;

    const handleStart = () => {
        if (locked) return;
        window.location.href = `/story?story_id=${story.id}`;
    };

    return (
        <article className={`story-card${isCompleted ? " story-card--completed" : ""}${locked ? " story-card--locked" : ""}`}>
            <div className="story-card__header">
                {locked ? (
                    <span className="story-card__badge">Locked</span>
                ) : isCompleted ? (
                    <span className="story-card__badge story-card__badge--completed">Completed</span>
                ) : (
                    <span className="story-card__badge story-card__badge--unlocked">Incomplete</span>
                )}

                {locked && (
                    <div className="story-card__lock-icon-wrapper">
                        <LockIcon size={16} />
                    </div>
                )}
            </div>

            <div>
                <h4 className="story-card__title">{story.title}</h4>
                <p className="story-card__subtitle">{story.subtitle}</p>
            </div>

            <div className="story-card__footer">
                {!locked && (
                    <div className="story-card__progress-container">
                        <div className="story-card__progress-label">
                            <span>Best Score</span>
                            <span>{Math.round(story.familiarity_score * 100)}%</span>
                        </div>
                        <div className="story-card__progress-bar">
                            <div
                                className={`story-card__progress-fill${isCompleted ? " story-card__progress-fill--completed" : ""}`}
                                style={{ width: `${Math.round(story.familiarity_score * 100)}%` }}
                            />
                        </div>
                    </div>
                )}

                <button
                    className={`story-card__btn ${locked ? "story-card__btn--secondary" : "story-card__btn--primary"}`}
                    onClick={handleStart}
                    disabled={locked}
                >
                    <BookIcon size={16} />
                    <span>{locked ? `Locked (Complete Unit ${story.min_sequence})` : isCompleted ? "Review Story" : "Read Story"}</span>
                </button>
            </div>
        </article>
    );
}

export default StoryCard;
